
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const XRay = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M13.2,10.2a10.2,10.2,0,0,1,4.4,1.3l.8-1.3a12,12,0,0,0-5.2-1.5V7.4H11.7V8.7a12,12,0,0,0-5.1,1.5l.8,1.3a9.4,9.4,0,0,1,4.3-1.3v1.3a8.9,8.9,0,0,0-5.1,1.9l.8,1.2A7.9,7.9,0,0,1,11.7,13v1.3a9.1,9.1,0,0,0-4.1,1.4L8.5,17a6.6,6.6,0,0,1,3.2-1.2v1.7H10.4V19h4.1V17.5H13.2V15.8A6.6,6.6,0,0,1,16.5,17l.9-1.3a9.1,9.1,0,0,0-4.2-1.4V13a7.6,7.6,0,0,1,4.3,1.6l.9-1.2a8.9,8.9,0,0,0-5.2-1.9Z"></path>
            <path d="M17.3,4.1V1.6H15.8V4.1H9.2V1.6H7.7V4.1H2.8V21.9H18.9a3.3,3.3,0,0,0,3.3-3.3V4.1Zm3.4,14.5a1.8,1.8,0,0,1-1.8,1.8H4.3V5.6H7.7V7.4H9.2V5.6h6.6V7.4h1.5V5.6h3.4Z"></path>
          </g>
        </g>
      </g>
    </IconBase>);
};

XRay.defaultProps = {
  title: 'X-Ray',
};

export default XRay;
